import React from "react";
import styled from "styled-components";
import { ReactComponent as Tick } from "../assets/components-icons/tick.svg";
import { useHistory } from "react-router-dom";
import { Button } from '../components/Layout/Elements'

export const Complete = () => {
  const history = useHistory();
  return (
    <CompleteWrapper>
      <div className="wrapper-div">
        <Tick className="tick-svg" />
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, ea?
        </p>
        <Button
        bg='var(--navbar-bg)'
        radius='40px'
        padding='10px'
        width='100%'
        maxWidth='300px'
        fontSize='15px'
        fontWeight='bold'
        onClick={() => history.push('/')}> Go back to dishes </Button>
      </div>
    </CompleteWrapper>
  );
};

const CompleteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tick-svg {
    width: 220px;
    height: 220px;
    fill: #e9e9e9;
  }

  a {
    border: none;
    border-radius: 40px;
    width: 70%;
    padding: 15px;
    text-align: center;
    background: var(--color2);
    text-decoration: none;
  }

  min-height: calc(100vh - 70px);

  a span {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
  }

  p {
    color: var(--checkout-product-descr);
    font-size: 16px;
    text-align: center;
  }

  .wrapper-div {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wrapper-div p {
    margin-top: 15px;
  }

  .wrapper-div button {
    margin-top: 15px;
    margin-bottom: 15px;
  }
`;

export { Complete as default };
